export default "__VITE_ASSET__ec104095__"